<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "AddCostIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
